export { StyledPageHeader } from "./StyledPageHeader";
